// src/api/terms/termsApi.ts
import { axiosInstance } from "src/api/axiosInstance";
import type { ApiResponse, PageContent } from "src/api/common/apiTypes";
import type { TermsItem } from "src/store/terms";

export type GetTermsParams = {
  termsType?: string;
  termsStatus?: string;
  termsCode?: string;
  applyStrDatetime?: string;
  applyEndDatetime?: string;
  page: number;
  size: number;
  order: string;
};

export const getTermsListApi = async (
  params: GetTermsParams
): Promise<ApiResponse<PageContent<TermsItem>>> => {
  const res = await axiosInstance.get<ApiResponse<PageContent<TermsItem>>>("/v1/admin/terms/list", {
    params: {
      ...params,
      termsType: params.termsType || undefined,
      termsStatus: params.termsStatus || undefined,
      termsCode: params.termsCode || undefined,
      applyStrDatetime: params.applyStrDatetime || undefined,
      applyEndDatetime: params.applyEndDatetime || undefined,
    },
  });

  return res.data;
};

// CREATE/UPDATE/DELETE는 그대로 (payload에 termsCode만 포함되면 됨)
export const createTermsApi = async (
  payload: Partial<TermsItem>
): Promise<ApiResponse<TermsItem>> => {
  const res = await axiosInstance.post<ApiResponse<TermsItem>>("/v1/admin/terms", payload);
  return res.data;
};

export const updateTermsApi = async (
  termsId: number,
  payload: Partial<TermsItem>
): Promise<ApiResponse<TermsItem>> => {
  const res = await axiosInstance.put<ApiResponse<TermsItem>>(
    `/v1/admin/terms/${termsId}`,
    payload
  );
  return res.data;
};

export const deleteTermsApi = async (termsId: number): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.delete<ApiResponse<null>>(`/v1/admin/terms/${termsId}`);
  return res.data;
};
